import { Route } from 'react-router-dom';
import { factureViewSchema } from './factureView';
import { factureSchema } from '@app/Modules/data/Facture/facture';
import Main from '@app/main/tables/Main';
import FactureDetails from './FactureDetails';

/**
 * Routes configurées pour le module FactureView
 */
const FactureViewRoutes = [
    // Route de liste (principale)
    <Route
        key="factures-view"
        path="factures"
        element={
            <Main key="factures-view-main" pageConfig={factureViewSchema} />
        }
    />,
    <Route
        key="factures-view"
        path="factures/data/factures"
        element={<Main key="factures-view-main" pageConfig={factureSchema} />}
    />,
    // Route de détails
    <Route
        key="factures-details"
        path="factures/:id/details"
        element={<FactureDetails />}
    />,
];

export default FactureViewRoutes;
